import React from 'react'
import Title from '../typo/Title'
import ItemList from '../configuration/ItemList'
import I18n from 'resources/i18n/I18n'
import Logo from '../logo/Logo'
const Stats = () => {
  return (
    <div className="container-fluid">
      <Logo />
      <div className="container">
        <div className="row">
          <Title text={I18n.t('StatsTitle')} />
        </div>
        <div className="row">
          <ItemList
            title={I18n.t('StatsDashboardTitle')}
            subtitle={I18n.t('StatsDashboardSubTitle')}
            path="/statistiques/tableau-de-bord"
            iconType="icon-bar-chart"
          />
          <ItemList title={I18n.t('StatsMapTitle')} subtitle={I18n.t('StatsMapSubTitle')} path="/statistiques/carte" iconType="icon-map" />
          <ItemList
            title="Suivi des incivilités"
            subtitle="Accéder au rapport du Suivi des incivilités, nécessite un droit d'accès spécifique, rapprochez vous de votre référent sûreté ou gestionnaire ORFI de votre organisme."
            path={process.env.REACT_APP_POWER_BI_SDI_URL}
            iconType="icon-powerbi"
            openNewTab
          />
        </div>
      </div>
    </div>
  )
}
export default Stats
